'use client'

import { type ReactNode } from 'react'

interface AuthTemplateProps {
	children: ReactNode
	/** Optional background element (e.g., animated gradient) */
	background?: ReactNode
}

/**
 * Template for authentication pages (login, register, forgot-password).
 * Centers content vertically with optional decorative background.
 */
export function AuthTemplate({ children, background }: AuthTemplateProps) {
	return (
		<div className="bg-brand-background relative flex min-h-svh w-full items-center justify-center overflow-hidden">
			{background && <div className="pointer-events-none absolute inset-0">{background}</div>}
			<div className="relative z-10 w-full max-w-md px-4 py-8">{children}</div>
		</div>
	)
}
